import { render, staticRenderFns } from "./calculateQuote.vue?vue&type=template&id=2f88b00c&scoped=true&"
import script from "./calculateQuote.vue?vue&type=script&lang=js&"
export * from "./calculateQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88b00c",
  null
  
)

export default component.exports